<!-- 分类管理-产品管理-新增产品-->
<template>
  <div>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-form :inline="true" class="demo-form-inline" style="padding:0;margin:0">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" @keyup.enter.native="handleSearch()" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleSearch" :loading="loading">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="80"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="库存" min-width="80"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="80"></el-table-column>
          <el-table-column label="采购价格" min-width="70">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.PRODUCT_PRICE" placeholder="请输入" clearable
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="销售价格" min-width="70">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.SALE_PRICE" placeholder="请输入" clearable
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="数量" min-width="70">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.NEED_COUNT" placeholder="请输入" clearable
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="addProduct(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="float: right; margin-top: 20px">
      <el-col>
        <el-button size="small" @click="submitReturn">确认</el-button>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: left; margin-top: 20px">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { queryWarehouseFun, addNewProduct } from 'api/warehouseManager';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      loading: false,
      ADD_STATUS: 1,
      searchForm: {},
      tableData: [],
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      addDis: true,
      tmpArr: [],
      productID: '',
      productCount: '',
      stockOutTcId: sessionStorage.getItem('stockOutTcId'),
    };
  },
  methods: {
    addProduct(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // 正则：正数
          const reg1 = /(^([1-9]\d*)(.\d+)?$)|(^(0{1})(.\d+){1}$)/;
          // 正则：正整数(后面可以跟.0000)
          const reg2 = /^([1-9]\d*)(\.0+)?$/;
          if (Number(row.NEED_COUNT) > Number(row.PRODUCT_COUNT)) {
            this.$message.show({ text: '不能大于库存数量', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!validation.价格正数0验证(row.PRODUCT_PRICE)) {
            this.$message.show({ text: '请输入采购价格', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!validation.价格正数0验证(row.SALE_PRICE)) {
            this.$message.show({ text: '请输入销售价格', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (util.JudgmentUnit(row.TYPE_UNIT)) {
            if (!reg1.test(row.NEED_COUNT)) {
              this.$message.show({ text: '请输入正数出库数量', type: 'warning' });
              document.body.style.cursor = 'default';
              return false;
            }
          } else if (!reg2.test(row.NEED_COUNT)) {
            this.$message.show({ text: '请输入正整数出库数量', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          const params = {
            BATCH: row.BATCH,
            COUNT: Number(row.NEED_COUNT),
            REAL_PRICE: Number(row.PRODUCT_PRICE),
            PROJECT_PRICE: Number(row.SALE_PRICE),
            ORDER_ID: Number(sessionStorage.getItem('oreder_id')),
            PRODUCT_CODE: Number(row.PRODUCT_CODE),
          };
          addNewProduct(params).then((result) => {
            this.$message.show({ text: '添加成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    submitReturn() {
      this.$router.push({ name: 'stockOutDetail' });
    },
    handleSearch() {
      const params = {
        PRODUCT_NAME: this.searchForm.name,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: 0,
        FLAG: 0,
        TC_ID: this.stockOutTcId,
      };
      this.loading = true;
      queryWarehouseFun(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].OP_ROLE
          .map((item, index) => Object.assign(item, { NEED_COUNT: '' }));
        if (result[0].TOTAL_WORTH !== '') {
          this.total_price = result[0].TOTAL_WORTH;
        } else {
          this.total_price = 0;
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------分页
    handleCurrentChange() {
      this.handleSearch();
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/addProduct.vue